<template>
  <div class="sidebar-list-content">
    <vs-sidebar-group
      v-if="item.children && item.children.length"
      :title="item.label"
      :icon-pack="item.icon"
      :open="isSubLinkActive(item)"
    >
      <recursive-menu-item
        v-for="child in item.children"
        :key="child.code"
        :item="child"
        :redirect-link="redirectLink"
        :is-sub-link-active="isSubLinkActive"
        :active-index="activeIndex"
        @update:activeIndex="setIndexActive"
      />
    </vs-sidebar-group>

    <vs-sidebar-item
      v-else
      :icon-pack="item.icon"
      :index="item.code"
      :href="redirectLink(item.app)"
      @click="setIndexActive(item.code)"
    >
      <span class="hide-in-minisidebar">{{ item.label }}</span>
    </vs-sidebar-item>
  </div>
</template>

<script>
export default {
  name: 'RecursiveMenuItem',

  props: {
    item: {
      type: Object,
      required: true,
    },
    redirectLink: {
      type: Function,
      required: true,
    },
    isSubLinkActive: {
      type: Function,
      required: true,
    },
    activeIndex: {
      type: [String, Number],
      default: null,
    },
  },

  methods: {
    getActive() {
      return this.activeIndex
    },
    setIndexActive(index) {
      this.$emit('update:activeIndex', index)
    },
  },
}
</script>
